module.exports = __webpack_public_path__ + "img/dj.45454d32.png";